import React from "react";
import { Col, Row, Form, Button, Card, Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useNavigate } from "react-router-dom";
import ContactImg from "../assets/contact.jpg";
import Footer from "../components/Footer";

const Contact = () => {
  let navigate = useNavigate();
  return (
    <>
      <section className="login ">
        <Row className="mx-0 stud-test">
          <Col md={2}></Col>
          <Col md={8} className=" my-3">
            <Row className="">
              <Col md={7} className=" shadow-lg bg-white rounded-end">
                <h3 className="px-3 pt-4 pb-3 text-center">
                  We'll get in touch with you
                </h3>
                <Form className="p-3">
                  <Row>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="username">Full Name</Form.Label>
                        <Form.Control placeholder="Enter your full name" />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="email">Email Id</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter your email id"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="phone">Mobile no</Form.Label>
                        <Form.Control
                          type="tel"
                          placeholder="Enter your mobile number"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>Message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Enter your message"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group className="mb-3">
                    <Button variant="danger" className="w-100">
                      Contact Me
                    </Button>
                  </Form.Group>
                </Form>
              </Col>
              <Col
                md={5}
                className="px-0 bg-white shadow-lg pt-5 rounded-start"
              >
                {/* <h1 className="text-center">
                <i className="fas fa-user-check border text-success rounded-circle px-4 py-4"></i>
              </h1>
              <h5 className="text-center pb-3">On Sign Up, you can</h5>

              <p className="text-center">
                Already Sign Up?{" "}
                <span
                  className="fw-bolder sign"
                  onClick={() => navigate("/login")}
                >
                  Sign In
                </span>{" "}
                here
              </p> */}
                <p className="pt-5 pb-0">
                  <img
                    src={ContactImg}
                    alt="Job Image"
                    className="img-fluid opacity-75"
                  />
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
      <Footer />
    </>
  );
};

export default Contact;
